// 封装app的弹窗提醒
export function warn(content) {
  dsBridge.call("common.showToast", { content });
}

// 打开一个url
export function openUrl(url) {
  if (!url) {
    dsBridge.call("common.showToast", { content: "url不能为空" });
    return;
  }
  let osInfo = dsBridge.call("common.getOSInfo", "") || {};
  if (osInfo.device_type == "ios") {
    dsBridge.call(
      "NIODoBridge.openURL",
      "nio://fd.webview?url=" + encodeURIComponent(url)
    );
  } else {
    dsBridge.call(
      "NIODoBridge.openURL",
      "nio://extern.webview?url=" + encodeURIComponent(url)
    );
  }
}

// 打开app的某个页面
export function openPage(page) {
  if (!page) {
    dsBridge.call("common.showToast", { content: "path不能为空" });
    return;
  }
  // 示例：参考readme文档
  dsBridge.call("NIODoBridge.openURL", page);
}

// 退出到app的首页
export function exit(orderNo) {
  if (!orderNo) {
    dsBridge.call("common.showToast", { content: "taskId不能为空" });
    return;
  }
  let dict = {
    key: "REFRESH_POWER_TASK",
    data: { orderNo }
  };
  dsBridge.call("common.postNotificationFromHtmltoNative", dict);
  dsBridge.call("common.closeSyn");
}

// 开启加载中动画
export function showLoading() {
  dsBridge.call("NIODoBridge.showLoading", "");
}

// 隐藏加载中动画
export function hideLoading() {
  dsBridge.call("NIODoBridge.hideLoading", "");
  dsBridge.call("common.hideLoading", "");
}



// WEBPACK FOOTER //
// ./src/utils/appFunction.js